@if (isSelectedSystem()) {
<div id="manual-discover-panel" class="ot-panel">
  <div class="ot-row" i18n>
    <h1 class="ot-wizard-title ot-m-1" style="font-weight: 400">Manual product discovery for
      {{this.selectedSystem.systemName}}</h1>
  </div>
  <app-wizard [index]="index" [steps]="steps"></app-wizard>
  <div class="ot-wizard-panel-body">
    <ng-scrollbar #scrollbarRef>
      @if (state == ManualDiscoverState.SELECT) {
      <div animate.enter="enter-animation">
        @if (isLoading) {
        <div id="manual-discover-products-progress" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>Retrieving supported product information...</p>
          </div>
        </div>
        }
        @if (isError) {
        <div id="manual-discover-product-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div class="ot-row">
          <span class="ot-wizard-title ot-m-1" i18n>Select a product type to discover</span>
        </div>
        <div class="wizard-contents" style="height: calc(100vh - 372px);">
          <div class="ot-row">
            <div class="ot-row__column">
              <app-select [identifier]="'product-discover-type'" [options]="productOptions" [label]="'Product'"
                i18n-placeholder placeholder="Select product" (selected)="onProductSelected($event)"
                [readonly]="isLoading">
              </app-select>
            </div>
            <div class="ot-row__column"></div>
            <div class="ot-row__column"></div>
          </div>
        </div>
      </div>
      }
      @if (state == ManualDiscoverState.QUESTIONS) {
      <div animate.enter="enter-animation">
        @if (isWaitingForManualDiscoverPrompts) {
        <div id="manual-discover-validate-progress" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>Retrieving list of questions...</p>
          </div>
        </div>
        }
        @if (isError) {
        <div id="manual-discover-validate-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div class="ot-panel">
          <div class="ot-panel__body ot-pt-1">
            @if (!isWaitingForManualDiscoverPrompts && manualDiscoverPromptResponse && !isError) {
            <form [formGroup]="questionsForm" name="otsc-manual-discover-questions-form">
              @if (promptsList.length > 0) {
              @for (prompt of getPromptsByOrder(); track prompt) {
              @if (showPrompt(prompt.controlId, prompt)) {
              <div class="ot-row">
                <div class="ot-row__column">
                  @switch (prompt.control) {
                  @case ('TEXT') {
                  <div class="ot-form-control"
                    [ngClass]="{'ot-form-control--is-invalid' : showQuestionsError(prompt.controlId)}"
                    [style.max-width]="prompt.widthValue">
                    <label [for]="prompt" class="ot-form-control__label">
                      @if (prompt.required) {
                      <span class="ot-form-control--is-required">*</span>
                      }
                      <span>{{prompt.labelValue}}</span>
                    </label>
                    <input [formControlName]="prompt.controlId" [id]="prompt.controlId" [name]="prompt.controlId"
                      type="text" class="ot-input" [(ngModel)]="prompt.value" [placeholder]="prompt.placeholderValue"
                      [required]="prompt.required" />
                    <p id="{{prompt}}_requiredErrorMsg" class="ot-form-control__error-text" i18n>
                      The value is required.
                    </p>
                    @if (prompt.message !== '') {
                    <p class="ot-form-control__info-text">
                      {{prompt.questionTipValue}}</p>
                    }
                  </div>
                  }
                  }
                </div>
              </div>
              }
              }
              }
            </form>
            }
          </div>
        </div>
      </div>
      }
      @if (state == ManualDiscoverState.PRODUCTS) {
      <div animate.enter="enter-animation">
        @if (isValidating) {
        <div id="manual-discover-products-progress" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>Retrieving list of products...</p>
          </div>
        </div>
        }
        @if (!isValidating && instanceRows.length > 0) {
        <div id="test" class="ot-row">
          @if (instanceRows.length == 1) {
          <span class="ot-wizard-title ot-m-1" i18n>The following product was found. If you would like to generate the
            landscape information for this product please select it and click next.</span>
          }
          @if (instanceRows.length > 1) {
          <span class="ot-wizard-title ot-m-1" i18n>The following products were found. If you would like to generate the
            landscape information for any of these products please select them and click next.</span>
          }
        </div>
        }
        @if (isError) {
        <div id="manual-discover-validate-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div class="ot-row">
          <app-datatable [identifier]="'manual-discover-products-table'" style="width: 100%" [showcheckboxes]="true"
            [cols]="instanceCols" [rows]="instanceRows" [scroll]="false">
          </app-datatable>
        </div>
      </div>
      }
      @if (state == ManualDiscoverState.LANDSCAPE) {
      <div animate.enter="enter-animation">
        @if (isCreatingLandscape) {
        <div id="manual-discover-landscape-progress" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>Generating landscape files...</p>
          </div>
        </div>
        }
        @if (manualDiscoverLandscapeResponse &&
        manualDiscoverLandscapeResponse.status.success) {
        <div id="manual-discover-landscape-success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            @if (landscapeRows.length == 1) {
            <p class="ot-message__item" i18n>The landscape file has been successfully created.</p>
            }
            @if (landscapeRows.length > 1) {
            <p class="ot-message__item" i18n>The landscape files have been successfully created.</p>
            }
          </div>
        </div>
        }
        @if (isError) {
        <div id="manual-discover-validate-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div class="ot-row">
          <app-datatable [identifier]="'manual-discover-landscape-table'" style="width: 100%" [showcheckboxes]="false"
            [cols]="instanceCols" [rows]="instanceRows" [scroll]="false">
          </app-datatable>
        </div>
      </div>
      }
      @if (state == ManualDiscoverState.DISCOVER) {
      <div animate.enter="enter-animation">
        @if (isDiscovering) {
        <div id="manual-discover--progress" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>Discovering products...</p>
          </div>
        </div>
        }
        @if (isDiscoverComplete) {
        <div id="manual-discover--success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>Product discovery is complete!</p>
          </div>
        </div>
        }
      </div>
      }
    </ng-scrollbar>
  </div>
  <div class="ot-wizard-panel-footer ot-wizard-panel-footer--is-right-justified"
    [ngClass]="{'ot-flex--is-space-between' : index > 0, 'ot-wizard-panel-footer--is-right-justified' : index == 0 || !showBack()}">
    @if (showBack()) {
    <button [id]="prevButtonId" [disabled]="isBackDisabled()" role="button" (click)="back()" aria-label="Back"
      i18n-title title="Back"
      class="otsc-btn__back ot-mb-1 ot-mt-1 ot-btn ot-btn--is-micro ot-btn--is-icon-btn ot-ml-1">
      <div class="otsc-back_btn">
      </div>
    </button>
    }
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      @if (isError) {
      <button [id]="retryButtonId" [disabled]="isRetrying" role="button" otsc-button color="primary" (click)="retry()"
        i18n>Retry</button>
      }
      @if (showNext()) {
      <button [id]="nextButtonId" [disabled]="isNextDisabled()" role="button" otsc-button color="primary"
        (click)="next()" i18n>Next</button>
      }
      @if (index == 4 && isDiscoverComplete) {
      <button id="discover-complete-ok" role="button" otsc-button color="primary" (click)="next()" i18n>OK</button>
      }
      @if (!isDiscoverComplete) {
      <button [id]="cancelButtonId" role="button" [disabled]="isCancelDisabled()" otsc-button color="secondary"
        (click)="cancel()" i18n>Cancel</button>
      }
    </div>
  </div>
</div>
} @else {
<div id="enable-product-loading"
  class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" i18n>Loading...</div>
</div>
}